module.exports = __webpack_public_path__ + "img/step2-01.8ad31ebc.png";